var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.splash),expression:"splash"}],staticClass:"loadingBgc"},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('Splash',{ref:"splash"})],1)],1),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view',{})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }